import { getHttpStatus } from "@/utils/apiError";

const TOO_MANY_REQUESTS = 429;

export const isTooManyAttempts = (error: unknown): boolean =>
  getHttpStatus(error) === TOO_MANY_REQUESTS;
